// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import DatePickerPresentationPropsDefault from "@insite/mobius/DatePicker/presentationProps";
import Calendar from "@werner/XDL/Icons/Calendar";
import { floatingLabel, showPlaceholderStyle } from "@werner/XDL/PreStyle/formField";
import { xBaseTheme } from "@werner/XDL/types";
import { color } from "@werner/XDL/Utilities";
import { css } from "styled-components";

const calenderSize = 18;
export default {
    defaultProps: {
        ...DatePickerPresentationPropsDefault,
        mergeCss: true,
        calendarIconProps: {
            color: "common.ui3",
            src: Calendar,
            size: calenderSize,
            css: css`
                &&& {
                    padding: 0;
                }
                &:hover {
                    color: ${color("text.link")};
                }
            `,
        },
        placeholders: {
            dayPlaceholder: "DD",
            monthPlaceholder: "MM",
            yearPlaceholder: "YY",
            hourPlaceholder: "hr",
            minutePlaceholder: "min",
        },
        cssOverrides: {
            formField: css`
                ${floatingLabel}
            `,
            datePicker: css`
                &&& > .react-datetime-picker {
                    &,
                    &:disabled,
                    &:not(:disabled) &:hover,
                    &:focus,
                    &:focus-within {
                        padding: 36px 20px 10px 20px;
                    }

                    & > .react-datetime-picker__wrapper > .react-datetime-picker__calendar-button {
                        width: ${calenderSize}px;
                        height: ${calenderSize}px;
                        margin-top: -12px;
                        margin-left: 20px;
                        z-index: 9;
                    }

                    .react-datetime-picker__inputGroup__input {
                        ${showPlaceholderStyle}
                    }
                }
            `,
        },
    },
} as xBaseTheme["datePicker"];
